import { gql } from '@apollo/client'

export interface TokenData {
  derivedETH: string
  feesUSD: string
  name: string
  symbol: string
  totalValueLocked: string
  totalValueLockedUSD: string
  txCount: string
  volume: string
  volumeUSD: string
}

export const TokenQuery = gql`
  query Token($address: String) {
    token(id: $address) {
      symbol
      name
      derivedETH
      volumeUSD
      volume
      txCount
      totalValueLocked
      feesUSD
      totalValueLockedUSD
    }
  }
`
